import { render } from "./ProfileV1.3.vue?vue&type=template&id=63d49e5f&scoped=true"
import script from "./ProfileV1.3.vue?vue&type=script&lang=js"
export * from "./ProfileV1.3.vue?vue&type=script&lang=js"

import "./ProfileV1.3.vue?vue&type=style&index=0&id=63d49e5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d49e5f"]])

export default __exports__